import Vue from 'vue'
import meta from '../../bankrate-tracking/meta'
import cookieEvent from './../bankrate-events'
import brUtils from './../../bankrate-utilities'

window.dataLayer = window.dataLayer || []

let eachRecursive = function eachRecursive(obj, cb) {
  for (let k in obj) {
    if (!obj.hasOwnProperty(k)) {
      continue
    }

    if (typeof obj[k] === 'object' && obj[k] !== null) {
      eachRecursive(obj[k], cb)
    } else {
      if (cb) {
        cb(obj, k)
      }
    }
  }
}

let bankrateGaDataLayer = new Vue({
  data: function() {
    return {
      pid: 'br3'
    }
  },
  methods: {
    setInitDataLayer: function setDataLayer() {
      let newLayer = {
        adArea: 'AdArea',
        adKeywords: 'AdKeyword',
        primaryCategory: 'Category',
        cobrand: 'Site',
        pageType: 'PageType',
        subCategories: 'SubCategories',
        content: {
          author: 'Author',
          date: 'Published',
          funnelStage: 'FunnelStage',
          targetPersona: 'TargetPersona',
          objective: 'Objective',
          topic: 'Topic'
        }
      }
      eachRecursive(newLayer, function(obj, key) {
        let value = meta.getMetaData(obj[key])
        obj[key] = value && key !== 'title' ? value : null
      })
      newLayer.content.title = window.document.title
      newLayer.pageUX = meta.getPageUX()
      newLayer.environ = 'cb'
      newLayer.event = 'preload'

      window.dataLayer.push(newLayer)
    },
    injectGTM: function injectGTM() {
      ;(function(w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        })
        let f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l !== 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', 'GTM-N74D8C')

      cookieEvent.$emit('GTMReady')
    }
  }
})

let initEvent =
  brUtils.getBrOption('GTMinitOn') !== null
    ? brUtils.getBrOption('GTMinitOn')
    : 'pid.loaded'

cookieEvent.$once(
  initEvent,
  function(pid) {
    if (window === window.top) {
      this.pid = pid
      this.setInitDataLayer()
      this.injectGTM()
    }
  }.bind(bankrateGaDataLayer)
)

// TODO: make something more elegant
cookieEvent.$once(
  'ratetableError',
  function(pid) {
    if (window === window.top) {
      this.pid = pid
      this.setInitDataLayer()
      this.injectGTM()
    }
  }.bind(bankrateGaDataLayer)
)

export default bankrateGaDataLayer
